module.exports = __webpack_public_path__ + "img/loading_dark.cc045ecb.svg";